import axios from "axios";
import { ticketBaseURL } from "../config/api";

export const post_Subscription = async (data: any) => {
    const response = await axios({
        url: `${ticketBaseURL}mycdirSubscription`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const getSubscriptionByGroupId = (tenantId: string) => {
    return getFetch(`mycdirSubscription/GetLatestMycdirSubscriptionByTenantId,${tenantId}`)
}

const getFetch = async (url: string, params = {}) => {
    const response = await axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    });
    return response.data;
}